<template>
    <div class="content">
        <div class="modal-overlay" v-if="showPop">
            <div class="modal-container modal-containers">
                <!-- 头部：警告标题 + 关闭按钮 -->
                <div class="modal-header">
                    <div class="title-wrapper">
                        <div class="warning-icon">
                            <span>⚠️</span>
                        </div>
                        <h2 class="modal-title">Attention: "Trading" destination</h2>
                    </div>
                    <button class="modal-close" @click="handleClose('showPop')">×</button>
                </div>

                <!-- 提示文本 -->                       
                <div class="modal-content">
                    <p class="modal-desc">
                        Amounts deposited to this destination are exclusively for <strong>trading</strong> and
                        <strong>cannot be used</strong> for investments. After depositing, <strong>there is no
                            reversal</strong>.
                    </p>

                    <!-- 选项组 -->
                    <div class="options-group">
                        <!-- 选项1：交易选项（风险提示） -->
                        <label class="option-item risk" :class="{ active: selectedOption === 'trading' }">
                            <div class="option-radio" style="border: #E99A9C 1px solid;">
                                <i class="iconfont icon-jinggao"></i>
                            </div>
                            <div class="option-content">
                                <div class="option-title" style="color:#FDE1E1;">I understand the risks and want to trade anyway</div>
                                <div class="option-subtitle" style="color:#C7A3A7;">Deposits are non-reversible.</div>
                            </div>
                        </label>

                        <!-- 选项2：投资选项（推荐） -->
                        <label class="option-item investment" :class="{ active: selectedOption === 'investment' }">
                            <div class="option-radio">
                                <i class="iconfont icon-duigou"></i>
                            </div>
                            <div class="option-content">
                                <div class="option-title" style="color:#BAE2E8;">Got it, I'll choose the investment option</div>
                                <div class="option-subtitle" style="color:#85C8D1;">Ideal for daily yields.</div>
                            </div>
                        </label>
                    </div>

                    <!-- 底部提示 -->
                    <p class="modal-footer-tip">You can close this window to keep choosing.</p>
                </div>
            </div>
        </div>
        <div class="modal-overlay" v-if="visible">
            <div class="modal-container">
                <!-- 头部 -->
                <div class="modal-header">
                    <h2 class="modal-title">Antes de continuar</h2>
                    <button class="modal-close" @click="handleClose('visible')">×</button>
                </div>

                <div class="modal-divider"></div>

                <!-- 选项卡 -->
                <div class="tab-group">
                    <button class="tab-btn" :class="{ active: activeTab === 'CPF' }" @click="activeTab = 'CPF'">
                        CPF
                    </button>
                    <button class="tab-btn" :class="{ active: activeTab === 'CNPJ' }" @click="activeTab = 'CNPJ'">
                        CNPJ
                    </button>
                </div>

                <!-- 提示文本 -->
                <div class="modal-content">
                    <p class="modal-desc">
                        Informe seu {{ activeTab }} para gerar o Pix.
                    </p>
                    <p class="modal-tip">Digite apenas numeros</p>

                    <!-- 输入框 -->
                    <input type="text" class="modal-input"
                        :placeholder="activeTab === 'CPF' ? '000.000.000-00' : '00.000.000/0000-00'"
                        v-model="inputValue" />
                </div>

                <!-- 按钮组 -->
                <div class="modal-actions">
                    <button class="btn btn-cancel" @click="handleCancel">Cancelar</button>
                    <button class="btn btn-continue" @click="handleContinue">Continuar</button>
                </div>
            </div>
        </div>

        <!-- 顶部导航 -->
        <div class="page-header">
            <div class="box">
                <button class="back-btn" @click="handleBack">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M19 12H5"></path>
                        <path d="M12 19l-7-7 7-7"></path>
                    </svg>
                </button>
                <h1 class="page-title">Deposit</h1>
                <a class="more-icon">⋮</a>
            </div>
            <div class="tabs">
                <div class="tab-item">Quick deposit</div>
            </div>
        </div>
        <div style="height: 125px;"></div>
        <!-- 支付方式选择 -->
        <div class="card">
            <div class="card-title">Payment methods</div>
            <div class="payment-methods">
                <div class="payment-card" :class="{ 'active': selectedPayment === 'pix' }"
                    @click="selectedPayment = 'pix'">
                    <div class="payment-icon">
                        <img src="../../assets/images/1a.png" alt="">
                    </div>
                    <div class="flex">
                        <div class="payment-name">PIX</div>
                        <div class="payment-desc">Instantaneo BRL</div>
                    </div>
                </div>
                <div class="payment-card" :class="{ 'active': selectedPayment === 'usdt' }"
                    @click="selectedPayment = 'usdt'">
                    <div class="payment-icon">
                        <img src="../../assets/images/2a.png" alt=""></img>
                    </div>
                    <div class="flex">
                        <div class="payment-name">USDT</div>
                        <div class="payment-desc">Stablecoin multi-rede</div>
                    </div>
                </div>
                <div class="payment-card" :class="{ 'active': selectedPayment === 'usdc' }"
                    @click="selectedPayment = 'usdc'">
                    <div class="payment-icon">
                        <img src="../../assets/images/3a.png" alt=""></img>
                    </div>
                    <div class="flex">
                        <div class="payment-name">USDC</div>
                        <div class="payment-desc">Stablecoin BEP20</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-title">网络 <span style="color: #E99A9C;">*</span></div>
            <div class="payment-methods">
                <div class="payment-card" @click="selectedPayment = 'pix'">
                    <div v-if="selectedDestination === 'investment'" class="destination-tag">Selected</div>
                    <div class="flex">
                        <div class="payment-name">PIX</div>
                        <div class="payment-desc">Instantaneo BRL</div>
                    </div>
                </div>
                <div class="payment-card" @click="selectedPayment = 'usdt'">
                    <div v-if="selectedDestination === 'investment'" class="destination-tag">Selected</div>
                    <div class="flex">
                        <div class="payment-name">USDT</div>
                        <div class="payment-desc">Stablecoin multi-rede</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-title">存款目的地 <span style="color: #E99A9C;">*</span></div>
            <div class="deposit-destination">
                <div class="destination-item" :class="{ active: selectedDestination === 'investment' }"
                    @click="selectedDestination = 'investment'">
                    <div class="destination-title">投资</div>
                    <div class="destination-desc">
                        合约，请将资金存入此账户
                    </div>
                    <div v-if="selectedDestination === 'investment'" class="destination-tag bgs">Selected</div>
                </div>
                <div class="destination-item" :class="{ active: selectedDestination === 'trading' }"
                    @click="selectedDestination = 'trading'">
                    <div class="destination-title">贸易</div>
                    <div class="destination-desc">
                        如果您有经验并希望利用杠杆进行自主交易,请将资金存入此账户。 <span class="high-risk">风险较高。</span>
                    </div>
                    <div v-if="selectedDestination === 'trading'" class="destination-tag bgs">Selected</div>
                </div>
            </div>
        </div>
        <!-- 支付金额输入区 -->
        <div class="section">
            <div class="section-title">支付</div>
            <div class="input-wrapper">
                <input type="number" v-model="paymentAmount" class="amount-input" placeholder="0.00" min="5"
                    max="1000000" />
                <div class="input-suffix">
                    <span class="dollar-icon">$</span>
                </div>
            </div>
            <div class="limit-tip" style="color: #E99A9C;" v-if="errMsg != ''">
                {{ errMsg }}
            </div>
            <div class="limit-tip">限额: 5.00 美元 ~ 1,000,000.00 美元</div>
        </div>

        <!-- 到账金额展示区 -->
        <div class="section">
            <div class="section-title">我将收到</div>
            <div class="input-wrapper" style="padding-bottom: 24px;">
                <input type="text" v-model="receivedAmount" class="amount-input received" readonly
                    placeholder="0.0000" />
                <div class="input-suffix">
                    <span class="unit-text">USDT</span>
                </div>
                <div class="msg-box">
                    Rate (PIX deposit): 1 USDT = R$ 5.4900
                </div>
            </div>
        </div>

        <!-- 说明文字区 -->
        <div class="section info-section">
            <div class="info-item">A. 无费用。</div>
            <div class="info-item">
                B. 您可以扫描 USDT 二维码进行充值；请在 <span class="highlight">30分钟</span> 内完成支付。
            </div>
            <div class="info-item warn">
                <span class="warn-icon">⏳</span>
                代码过期后请重新充值；请勿保存截图以备后用！
            </div>
        </div>
        <div style="height: 120px;"></div>
        <!-- 底部按钮 -->
        <div class="submit-box">
            <button class="submit-btn" :disabled="!paymentAmount || paymentAmount < 5 || paymentAmount > 1000000"
                @click="submitFun">
                请输入金额
            </button>
            <div class="err-msg" v-if="errMsg != ''">
                {{ errMsg }}
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "Deposito",
    created() {
        this.$parent.footer("user", false);
    },
    data() {
        return {
            // 选中的支付方式
            selectedPayment: 'pix',
            // 选中的充值用途
            selectedDestination: 'investment',
            // 支付金额
            payAmount: '',
            // 汇率
            exchangeRate: 5.49,
            // 收款金额（计算得出）
            receiveAmount: '0.0000',
            errMsg: '',
            payAmount: '',
            receiveAmount: '',
            paymentAmount: '',
            receivedAmount: '',
            visible: false,
            showPop: false,
            activeTab: 'CPF',
            inputValue: '',
            selectedOption:''
        }
    },
    watch: {
        // 监听支付金额变化，计算收款金额
        payAmount(newVal) {
            if (newVal && this.selectedDestination === 'trading') {
                this.receiveAmount = (newVal / this.exchangeRate).toFixed(4);
            } else {
                this.receiveAmount = '0.0000';
            }
        },
        // 监听充值用途变化，重置收款金额
        selectedDestination(newVal) {
            if (newVal !== 'trading') {
                this.receiveAmount = '0.0000';
            } else if (this.payAmount) {
                this.receiveAmount = (this.payAmount / this.exchangeRate).toFixed(4);
            }
        }
    },
    methods: {
        // 返回按钮逻辑
        handleBack() {
            console.log('Go back to previous page');
        },
        // 提交按钮逻辑
        handleSubmit() {
            if (!this.payAmount || this.payAmount < 30) {
                alert('Please enter a valid amount (minimum R$30)');
                return;
            }
            console.log('Deposit submit:', {
                paymentMethod: this.selectedPayment,
                destination: this.selectedDestination,
                payAmount: this.payAmount,
                receiveAmount: this.receiveAmount
            });
            // 这里可以添加提交充值请求的逻辑
        },
        handleClose(type) {
            console.log(type)
            this.$set(this, type, false);
        },
        handleCancel() {
            this.inputValue = ''
            this.$emit('update:visible', false)
        },
        handleContinue() {
            this.$emit('confirm', {
                type: this.activeTab,
                value: this.inputValue.replace(/\D/g, '')
            })
        },
        submitFun() {
            this.visible = true;
        }
    }
}
</script>
<style scoped lang="less">
.content {
    width: 100%;
    height: fit-content;
    background: rgb(6, 14, 23);
    background-image: radial-gradient(760px 440px at 95% 0%, rgba(250, 204, 21, .11), transparent 62%), radial-gradient(840px 560px at -10% 2%, rgba(56, 189, 248, .08), transparent 64%), radial-gradient(780px 520px at 42% 100%, rgba(52, 211, 153, .07), transparent 64%);
}

/* 顶部导航 */
.page-header {
    height: 115px;
    margin-bottom: 20px;
    position: relative;
    position: fixed;
    left: 50%;
    top: 0px;
    transform: translateX(-50%);
    width: 100%;
    max-width: 520px;
    background-image: linear-gradient(98deg, #133329, #0f2635 48%, #0b1b2c);
    z-index: 99;

    .box {
        width: 100%;
        display: flex;
        align-items: center;
        height: 60px;
        border-bottom: 1px solid #1E303F;
        padding: 0px 15px;

        .more-icon {
            margin-left: auto;
        }
    }

    .tabs {
        width: 100%;
        height: 55px;
        padding: 7px 10px;
    }
}

.more-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 24px;
}

.back-btn {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background: rgba(0, 40, 30, 0.5);
    border: 1px solid rgba(0, 180, 120, 0.2);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.back-btn:hover {
    background: rgba(0, 40, 30, 0.8);
}

.page-title {
    font-size: 16px;
    color: #fff;
    margin-left: 10px;
    font-weight: 700;
}

/* 标签栏 */
.tabs {
    width: 100%;
    height: 100%;
    font-size: 14px;
    border: 1px solid rgba(0, 180, 120, 0.2);
}

.tab-item {
    width: 100%;
    height: 100%;
    font-size: 14px;
    font-weight: 600;
    color: #B7EDF2;
    cursor: pointer;
    background: #184436;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, rgba(24, 68, 54, 1) 0%, rgba(20, 50, 70, 1) 100%);
    border-radius: 8px;
    transition: all 0.2s ease;
    border: 1px solid #B7EDF2;
}


/* 通用卡片样式 */
.card {
    width: 96%;
    margin: 0 auto 15px auto;
    background: #0A1F25;
    border-radius: 12px;
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid rgba(0, 180, 120, 0.2);
}

.card-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 16px;
    color: rgba(255, 255, 255, 0.9);
}

/* 支付方式选择 */
.payment-methods {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.payment-card {
    background: #192A36;
    border-radius: 10px;
    padding: 20px 10px;
    border: 1px solid rgba(0, 180, 120, 0.2);
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;

    .flex {
        display: flex;
        flex-direction: column;
    }
}


.payment-card.active {
    border: #375B69 solid 1px;
    background: #0C1F31;
    box-shadow: 0px 2px 4px #1b3c5c;
}

.payment-methods .payment-card:nth-child(2).active {
    border: #404436 solid 1px;
    background: #0C1F31;
    box-shadow: 0px 2px 4px #525A46;
}

.payment-card.active::after {
    content: '';
    position: absolute;
    top: 0px;
    right: 0px;
    width: 24px;
    height: 24px;
    background: #00b478 url('../../assets//images/dui.png') no-repeat center center / 60%;
    border-radius: 0px 0px 0px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

.payment-icon {
    width: 38px;
    height: 38px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    border: 1px solid #25497D;
    overflow: hidden;
    margin-right: 10px;

    img {
        display: block;
        width: 100%;
        height: 100%;
    }
}

.payment-name {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
    color: #ffffff;
}

.payment-desc {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.6);
}

/* 充值用途选择 */
.deposit-destination {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.destination-item {
    background: #182937;
    border-radius: 12px;
    padding: 16px;
    border: 1px solid #25383A;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
}

.destination-item.active {
    border-color: #295075;
    background: #0C1F30;
}

.bgs {
    background: #FCD34D !important;
}

.destination-tag {
    position: absolute;
    top: 12px;
    right: 12px;
    background: #22D3EE;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: 600;
}

.destination-title {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 8px;
}

.destination-desc {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 18px;
}

.high-risk {
    color: #FCD34D;
    font-weight: 600;
}

/* 金额输入区域 */
.amount-input-wrap {
    position: relative;
    margin-bottom: 8px;
}

.amount-input {
    width: 100%;
    height: 54px;
    background: rgba(0, 60, 45, 0.6);
    border: 1px solid rgba(0, 180, 120, 0.2);
    border-radius: 12px;
    padding: 0 16px;
    color: #fff;
    font-size: 24px;
    font-weight: 600;
}

.amount-input:focus {
    outline: none;
    border-color: #00b478;
}

.currency-tag {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
}

.limit-text {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 20px;
    padding-left: 16px;
}

/* 收款金额区域 */
.receive-amount-wrap {
    margin-bottom: 20px;
}

.receive-label {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 8px;
}

.rate-text {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    margin-top: 4px;
    padding-left: 16px;
}

/* 提示信息区域 */
.tips-section {
    font-size: 14px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 24px;
}

.tips-section p {
    margin-bottom: 8px;
}

.tips-section span {
    color: #00b478;
    font-weight: 600;
}

/* 底部按钮 */
.submit-btn {
    width: 100%;
    height: 60px;
    background: linear-gradient(90deg, #00d186, #00b478);
    border: none;
    border-radius: 12px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.submit-btn:hover {
    background: linear-gradient(90deg, #00bb78, #009e6a);
}

.submit-btn:disabled {
    background: rgba(0, 180, 120, 0.5);
    cursor: not-allowed;
}

.section {
    width: 96%;
    background-color: #1a2635;
    border-radius: 12px;
    padding: 16px;
    margin: 0 auto 15px auto;
    border: 1px solid rgba(0, 180, 120, 0.2);
}

.section-title {
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 12px;
}

.input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid #D3D6DB;
    border-radius: 12px;
    padding: 4px 15px;
    background-color: #0D222A;

    .msg-box {
        width: 100%;
        padding: 0px 15px;
        position: absolute;
        left: 0px;
        bottom: 15px;
        z-index: 1;
        color: #8a9bb3;
    }
}

.amount-input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: #ffffff;
    font-size: 18px;
    padding: 16px 0;
}

.received {
    color: #C7EFDC !important;
}

.input-suffix {
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    padding: 0 12px;
    height: 32px;
    border: 1px solid #D3D6DB;
    border-radius: 8px;
    background: rgba(84, 99, 101, 0.5);
}

.dollar-icon,
.unit-text {
    color: #ffffff;
    font-size: 12px;
    font-weight: 500;
}

.dollar-icon {
    font-size: 14px;
}

.limit-tip {
    color: #8a9bb3;
    font-size: 10px;
    margin-top: 8px;
}

.info-section {
    color: #ffffff;
    line-height: 1.6;
}

.info-item {
    margin-bottom: 8px;
    font-size: 10px;
}

.highlight {
    color: #f9d342;
    font-weight: 500;
}

.warn {
    color: #f9d342;
    display: flex;
    align-items: center;
}

.warn-icon {
    margin-right: 8px;
}

.submit-box {
    width: 100%;
    height: fit-content;
    position: relative;
    position: fixed;
    left: 50%;
    bottom: 0px;
    transform: translateX(-50%);
    max-width: 520px;
    z-index: 10;
    background: #102030;
    border-top: 1px solid #1E2B37;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px 10px 20px 10px;

    .err-msg {
        width: 100%;
        height: fit-content;
        padding: 10px;
        color: #BAC0C1;
        border: 1px solid #BAC0C1;
        margin-top: 10px;
        border-radius: 10px;
        background: #0D222A;
    }
}

.submit-btn {
    width: 100%;
    height: 48px;
    background-color: #34d399;
    color: #0f1722;
    border: none;
    border-radius: 12px;
    padding: 5px 15px;
    font-size: 14px;
    font-weight: 600;
    color: #222;
}

.submit-btn:disabled {
    background-color: #2d7f5f;
    color: #222;
    cursor: not-allowed;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

/* 弹框容器 */
.modal-container {
    width: 90%;
    max-width: 500px;
    background-color: #0f293a;
    border-radius: 16px;
    padding: 24px;
    color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 头部 */
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.modal-title {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
}

.modal-close {
    background: none;
    border: none;
    color: #ffffff;
    font-size: 24px;
    cursor: pointer;
    padding: 0;
}

.modal-divider {
    height: 1px;
    background-color: #CACFD4;
    margin-bottom: 24px;
}

/* 选项卡 */
.tab-group {
    display: flex;
    border: 1px solid #CACFD4;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 20px;
}

.tab-btn {
    flex: 1;
    padding: 12px 0;
    background-color: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.tab-btn.active {
    background-color: #182C3B;
    color: #66d9ef;
    border: 1px solid #66d9ef;
    border-radius: 10px;
    margin: 2px;
}

/* 内容区域 */
.modal-content {
    margin-bottom: 24px;
}

.modal-desc {
    font-size: 12px;
    margin: 0 0 16px 0;
    line-height: 1.5;
}

.modal-tip {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 16px 0;
}

.modal-input {
    width: 100%;
    padding: 12px 15px;
    background: #0A1B2A;
    background: linear-gradient(90deg, rgba(10, 27, 42, 1) 0%, rgba(12, 34, 52, 1) 100%);
    border: 1px solid #213F51;
    border-radius: 12px;
    color: #ffffff;
    font-size: 16px;
    box-sizing: border-box;
}

.modal-input::placeholder {
    color: rgba(255, 255, 255, 0.3);
}

/* 按钮组 */
.modal-actions {
    display: flex;
    gap: 16px;
}

.btn {
    flex: 1;
    padding: 14px 5px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-cancel {
    background-color: transparent;
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #ffffff;
}

.btn-continue {
    background-color: #3CD8BE;
    border: none;
    color: #0f293a;
}

.btn-continue:hover {
    background-color: #30ceb3;
}
.modal-containers {
    /* 头部 */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.title-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.warning-icon {
  width: 32px;
  height: 32px;
  border: 1px solid #5B6251;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f7d060;
  font-size: 14px;
}

.modal-title {
    width: 70%;
  font-size: 18px;
  font-weight: 600;
  color: #FDE68A;
  margin: 0;
  line-height: 1.3;
}

.modal-close {
  background: none;
  border: none;
  color: #ffffff;
  font-size: 28px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

/* 内容区域 */
.modal-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.modal-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #ffffff;
  margin: 0;
  padding: 0 30px;
  word-break: break-all;
}

.modal-desc strong {
  font-weight: 600;
}

/* 选项组 */
.options-group {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.option-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 15px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* 风险选项样式 */
.option-item.risk {
  border: 1px solid rgba(237, 100, 106, 0.5);
}
.option-item.risk.active {
  border-color: #ed646a;
  background-color: rgba(237, 100, 106, 0.05);
}

/* 投资选项样式 */
.option-item.investment {
  border: 1px solid rgba(102, 217, 239, 0.5);
}
.option-item.investment.active {
  border-color: #66d9ef;
  background-color: rgba(102, 217, 239, 0.05);
}

/* 隐藏原生单选框 */
.option-radio {
  appearance: none;
  width: 28px;
  height: 28px;
  border: 1px solid #387C8F;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.option-radio:checked {
  border-color: currentColor;
}
.option-radio:checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: currentColor;
}

.option-item.risk .option-radio {
  color: #E99A9C;
}
.option-item.investment .option-radio {
  color: #66d9ef;
}

.option-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.option-title {
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
}

.option-subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

/* 底部提示 */
.modal-footer-tip {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}
}
</style>